import React from 'react';
import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import FAIcon from '../FAIcon';

const InfoMessageStyles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${color('primary', 'dark')};
  font-size: 14px;
`;

const SeeExampleLink = styled.span`
  color: ${color('custom', 'link')};
  text-decoration: underline;
  padding-left: 6px;
  cursor: pointer;
`;

export interface InfoMessageWithSeeExampleProps {
  message: string;
  showExample: () => void;
}

const InfoMessageWithSeeExample = ({ message, showExample }: InfoMessageWithSeeExampleProps) => {
  return (
    <InfoMessageStyles>
      <FAIcon icon="circle-info" />
      <span style={{ paddingLeft: '6px' }}>
        {message}
        <SeeExampleLink onClick={showExample}>See Example</SeeExampleLink>
      </span>
    </InfoMessageStyles>
  );
};

export default React.memo(InfoMessageWithSeeExample);
